import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"
import './MinimizeButton.less'

interface MinimizeButtonProps {
    onMinimize: () => void
    tooltipText?: string
    className?: string
}

export const MinimizeButton: React.FC<MinimizeButtonProps> = ({
                                                                  onMinimize,
                                                                  tooltipText = 'Minimize',
                                                                  className = ''
                                                              }) => {
    const buttonRef = useRef<HTMLButtonElement>(null)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        event.stopPropagation()
        onMinimize()
    }

    return (
        <div className={"minimize-button-container"}>
            <button
                ref={buttonRef}
                className={`minimize-button ${className}`}
                onClick={handleClick}
                aria-label="Minimize"
                title={tooltipText}
            >
                <Icon
                    name={IconName.Down}
                    className="minimize-icon"
                    width="20"
                    height="20"
                />
            </button>
        </div>
    )
}
